import axios from "axios";
import dotEnv from "dotenv";
dotEnv.config();

const apiURL = process.env.REACT_APP_BASE_URL;

const transactionLaneApi = ({ offerId, role, source, delegateSide, delegateOwnerId, screenType }) => {
  let accessTokan = localStorage.getItem("userAuth");
  return axios.get(`${apiURL}/RTD/${offerId}`, {
    cancelToken: source.token,
    params: {
      ...(role ? { role } : {}),
      ...(delegateSide ? { delegateSide } : {}),
      ...(delegateOwnerId ? { delegateOwnerId } : {}),
      ...(screenType && {screenType})
    },
    headers: {
      accept: "application/json",
      authorization: `bearer ${accessTokan}`,
    },
  });
};

const getTitleCompanyData = ({ offerId, source, delegateSide, delegateOwnerId, screenType }) => {
  const accessToken = localStorage.getItem("userAuth");
  return axios.get(`${apiURL}/getSelectedTitleCompanyData`, {
    cancelToken: source.token,
    params: {
      offerId,
      ...(delegateSide ? { delegateSide } : {}),
      ...(delegateOwnerId ? { delegateOwnerId } : {}),
      ...(screenType && {screenType})
    },
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
};


const individualTransactionApi = ({ offerId, propertyId, source, delegateSide, delegateOwnerId, screenType }) => {
  const accessToken = localStorage.getItem("userAuth");
  return axios.get(`${apiURL}/getIndividualTransaction`, {
    cancelToken: source.token,
    params: {
      ...(offerId ? { offerId } : propertyId ? { propertyId } : {}),
      ...(delegateSide ? { delegateSide } : {}),
      ...(delegateOwnerId ? { delegateOwnerId } : {}),
      ...(screenType ? {screenType} : {})
    },
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const getPropertyDocsRequest = ({ offerId, source, delegateSide, delegateOwnerId, section, screenType }) => {
  const accessToken = localStorage.getItem("userAuth");
  return axios.get(`${apiURL}/getSharedDocs`, {
    cancelToken: source.token,
    params: {
      offerId: offerId,
      ...(delegateSide ? { delegateSide } : {}),
      ...(delegateOwnerId ? { delegateOwnerId } : {}),
      ...(section && {section}),
      ...(screenType && {screenType})
    },
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
};


const draftDocumetnApi = (data) => {
  const accessToken = localStorage.getItem("userAuth");
  return axios.post(
    `${apiURL}/url/builtForSection`,
    {
      ...data,
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};
const generateresureSignApi = (data) => {
  const accessToken = localStorage.getItem("userAuth");
  return axios.post(
    `${apiURL}/resure-sign/generateFormLink`,
    {
      ...data,
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};
const updateDocumentApi = ({documentId, data, contractType, delegateSide,delegateOwnerId, emailSignatureId, emailMessage}) => {
  const accessToken = localStorage.getItem("userAuth");
  let apiUrl = `${apiURL}/offerDocument/${documentId}`;
  return axios.put(
    apiUrl,
    {
      ...data,
      ...(delegateSide ? { delegateSide } : {}),
      ...(delegateOwnerId ? { delegateOwnerId } : {}),
      ...(emailSignatureId ? {emailSignatureId} : {}),
      ...(emailMessage ? {emailMessage} : {}),
    },
    {
     headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
}

const getClientScreen = (params) => {

  let accessToken = localStorage.getItem("userAuth");
  return axios.get(
    `${apiURL}/clientRTD`,
    {
      params,

    headers: {
        accept: "application/json",
        authorization: `bearer ${accessToken}`,
      },
    }
  );
};


const getEmails_FilesApi = (params) => {
  let accessToken = localStorage.getItem("userAuth");
  return axios.get(
    `${apiURL}/emailsAndFiles`,
    {
    params,
    headers: {
        accept: "application/json",
        authorization: `bearer ${accessToken}`,
      },
    }
  );
};
const getClientDocRequest = (params) => {

  let accessTokan = localStorage.getItem("userAuth");
  return axios.get(`${apiURL}/propertyDocs`,{
      params,
      headers: {
        accept: "application/json",
        authorization: `bearer ${accessTokan}`,
      },
    }
  );
};
// used for hiding documents from RTD
const deleteFormRequest = ({documentId, offerId, delegateSide,delegateOwnerId, isToggleFrom, screenType,isResureSignDoc,showInTransactionDashboard}) => {
  const accessToken = localStorage.getItem("userAuth");
  let params = {
    ...(delegateSide && { delegateSide }),
    ...(delegateOwnerId && { delegateOwnerId }),
    ...(offerId && { offerId }),
    ...(isToggleFrom && {isToggleFrom}),
    ...(screenType && {screenType}),
    ...(isResureSignDoc && { isResureSignDoc: true }),
    ...(typeof showInTransactionDashboard === 'boolean'  && { showInTransactionDashboard:false })
  };
  return axios.delete(`${apiURL}/RTD/deleteForm/${documentId}`, {
    params,
    headers: {
      accept: "application/json",
      authorization: `bearer ${accessToken}`,
    },
  });
}

const urlShorthandApi = (data,source) => {
  let accessTokan = localStorage.getItem("userAuth");
  if(source === 'calendar'){
    return axios.post(`${apiURL}/url`,
      {
        ...data,
      },
      {
        headers: {
          accept: "application/json",
          authorization: `bearer ${accessTokan}`,
        },
      }
    );
  }else{
    return axios.post(`${apiURL}/url/builtForSection`,
      {
        ...data,
      },
      {
        headers: {
          accept: "application/json",
          authorization: `bearer ${accessTokan}`,
        },
      }
    );
  }
};

const addEmail = (data) => {
  const accessTokan = localStorage.getItem("userAuth");
  return axios.post(`${apiURL}/addClientDetail`,{...data},{
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessTokan}`,
    },
  })
}

const getNestedDoraDocuments = ({data, fiters, source, brokerageId}) => {
  let accessTokan = localStorage.getItem("userAuth");
  let params = {
    listType: data.listType,
    offerId: data.offerId,
    ...(fiters?.search ? {search: fiters?.search} : {}),
  }
  let url = `${apiURL}/nestedContractDocumentaries`;
  return axios.get( url,
    {
      params,
      cancelToken: source.token,
      headers: {
        accept: "application/json",
        authorization: `bearer ${accessTokan}`,
      },
    }
  );
};

const addTitleoffice = ({payload, delegateSide, delegateOwnerId, screenType, processorArr, affiliateArr, category}) => {
  let accessTokan = localStorage.getItem("userAuth");
  return axios.post(`${apiURL}/updateTitleOrderForm`,
  {
    ...payload,
    ...(delegateSide ? {delegateSide} : {}),
    ...(delegateOwnerId ? {delegateOwnerId} : {}),
    ...(processorArr?.length || category?.length ? {processors: processorArr} : {}),
    ...(affiliateArr?.length || category?.length ? {affiliates: affiliateArr} : {}),
    ...(screenType && {screenType})
  },
  {
    headers: {
      accept: "application/json",
      authorization: `bearer ${accessTokan}`,
    },
  });
};

const gettitlecompany=({type, id, search, source, getAll, page, dataPerPage})=> {
  const accessTokan = localStorage.getItem("userAuth");
  let query = "";
  if(type === "COMPANY"){
    query = `?titleType=TITLE_COMPANY&includeLimitedData=true`;
    if (getAll){
      query += `&getAll=true`;
      query += `&page=${page}`;
      query += `&limit=${dataPerPage}`;
      query = search?.length ? query + `&search=${encodeURIComponent(search)}` : query;
    }
  }
  else if(type==="OFFICE"){
    query = `?titleType=TITLE_OFFICE&parentId=${id}`;
    if(search){
      query += `&search=${encodeURIComponent(search)}`;
    }
  }
  return axios.get(`${apiURL}/titleOffice${query}`,{
    cancelToken: source.token,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessTokan}`,
  },
  })
}

const sendTitleCompanyDocument = (payload) => {

  const accessTokan = localStorage.getItem("userAuth");
  return axios.post(`${apiURL}/sendMultipleDocuments`,{...payload},{
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessTokan}`,
    },
  })
}

const deleteTitleCompanyData = ({ offerId, propertyId, delegateSide, delegateOwnerId, clearAffliates }) => {
  const accessToken = localStorage.getItem("userAuth");
  return axios.delete(`${apiURL}/clearTitleOrderFormData`, {
    params: {
      ...(offerId && {offerId}),
      ...(propertyId && {propertyId}),
      ...(delegateSide ? { delegateSide } : {}),
      ...(delegateOwnerId ? { delegateOwnerId } : {}),
      clearAffliates
    },
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

const getTitleCloserAndRepsRequest = ({sourceAxios, titleCompanyId, search}) => {
  const accessToken = localStorage.getItem("userAuth");
  return axios.get(`${apiURL}/getClosersAndSalesReps`, {
    cancelToken: sourceAxios.token,
    params: {
      titleCompanyId,
      ...(search?.length ? { search: search.trim() } : {}),
    },
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
}

const getChecklistDataApi = ({offerId, propertyId, source, delegateOwnerId, openFor}) => {
  const accessToken = localStorage.getItem("userAuth");
  return axios.get(`${apiURL}/offerDocCheckList`, {
    cancelToken: source.token,
    params: {
      offerId : offerId,
      propertyId: propertyId,
      openFor: openFor,
      ...(delegateOwnerId ? { delegateOwnerId } : {}),
    },
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
}

const getSourceOfBusinessApi = ({ source }) => {
  const accessToken = localStorage.getItem("userAuth");
  return axios.get(`${apiURL}/getConstants?constantType=SOURCE_OF_BUSINESS`, {
    cancelToken: source.token,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
}

const verifyUploadDocApi = ({ offerData = {}, signatureVerify, checked, showInChecklist, remove, buildData = {}, sourceOfBusiness = {}, openFor, offerId, urlData = {}, origin }) => {
  const accessToken = localStorage.getItem("userAuth");
  let apiUrl = `${apiURL}/offerDocCheckList`;
  return axios.put(
    apiUrl,
    {
      ...(offerData.fileUrl || offerData.isPropertyDoc ? { propertyDocId: offerData?._id } : { documentId: offerData?._id } ),
      ...(buildData?.fileLink ? { fileLink: buildData.fileLink } : {}),
      ...(buildData?.fileName ? { fileName: buildData.fileName } : {}),
      ...(buildData?.fileType ? { fileType: buildData.fileType } : {}),
      ...(Array.isArray(buildData.signatureOf) ? { signatureOf: buildData.signatureOf } : {}),
      ...(signatureVerify ? { signaturesVerified: true } : {}),
      ...(showInChecklist ? { showInChecklist: checked } : remove ? { showInChecklist: false } : {}),
      ...(sourceOfBusiness?.key ? {sourceOfBusiness: sourceOfBusiness} : {}),
      ...(openFor ? {openFor: openFor} : {}),
      ...(offerId ? {offerId: offerId} : {}),
      ...(origin?.length ? {...urlData} : {}),
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};

const editTitleCompanyDataInOfferRequest = ({ offerId, payload, source, propertyId }) => {
  const accessToken = localStorage.getItem("userAuth");
  return axios.put(`${apiURL}/editTitleCompanyDataToOffer`,
    {
      ...payload,
      offerId,
      ...((source === 'FROM_SELLING_MATRIX' && propertyId) ? { propertyId } : {}),
      ...(source && { source }),
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
}

export const transactionLaneDataApi = {
  transactionLaneApi,
  draftDocumetnApi,
  generateresureSignApi,
  updateDocumentApi,
  getClientScreen,
  getClientDocRequest,
  getEmails_FilesApi,
  deleteFormRequest,
  individualTransactionApi,
  getPropertyDocsRequest,
  getTitleCompanyData,
  urlShorthandApi,
  addEmail,
  getNestedDoraDocuments,
  addTitleoffice,
  gettitlecompany,
  sendTitleCompanyDocument,
  getTitleCloserAndRepsRequest,
  deleteTitleCompanyData,
  getChecklistDataApi,
  verifyUploadDocApi,
  editTitleCompanyDataInOfferRequest,
  getSourceOfBusinessApi,
};
